import React, { useId } from 'react';

// Brand-gradient "cards/grid view" icon (4 squares) for the Deal Flow view toggle.
// useId keeps the gradient + clipPath ids unique per instance, so multiple copies
// on one page can't collide (same pattern as SearchGradientIcon/FilterGradientIcon).
const GridViewGradientIcon = ({ size = 18, style = {} }) => {
  const id = useId();
  const g0 = `grid_g0_${id}`;
  const g1 = `grid_g1_${id}`;
  const g2 = `grid_g2_${id}`;
  const g3 = `grid_g3_${id}`;
  const clip = `grid_clip_${id}`;

  const stops = (
    <>
      <stop stopColor="#7852F8" />
      <stop offset="1" stopColor="#84AEF6" />
    </>
  );

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', ...style }}
    >
      <g clipPath={`url(#${clip})`}>
        <rect x="0.5" y="0.5" width="7" height="7" stroke={`url(#${g0})`} />
        <rect x="10.5" y="0.5" width="7" height="7" stroke={`url(#${g1})`} />
        <rect x="0.5" y="10.5" width="7" height="7" stroke={`url(#${g2})`} />
        <rect x="10.5" y="10.5" width="7" height="7" stroke={`url(#${g3})`} />
      </g>
      <defs>
        <linearGradient id={g0} x1="4" y1="0" x2="4" y2="8" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g1} x1="14" y1="0" x2="14" y2="8" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g2} x1="4" y1="10" x2="4" y2="18" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g3} x1="14" y1="10" x2="14" y2="18" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <clipPath id={clip}>
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GridViewGradientIcon;
